import Skeleton from "react-loading-skeleton";

import styles from "./left-side.module.scss";

type LeftSideLoading = {
  avatarSize?: number;
};

export function LeftSideLoading({ avatarSize = 120 }: LeftSideLoading) {
  return (
    <div className={styles.leftSideWrapper}>
      <div className={styles.infoWrapper}>
        <Skeleton circle width={avatarSize} height={avatarSize} />
        <div className={styles.info}>
          <h3>
            <Skeleton width={150} />
          </h3>
          <span>
            <Skeleton width={100} />
          </span>
        </div>
      </div>

      <div className={styles.description}>
        <Skeleton count={3} />
      </div>
    </div>
  );
}
